import type { TypingUser } from '@/types/messaging';

interface TypingIndicatorProps {
  users: TypingUser[];
}

export function TypingIndicator({ users }: TypingIndicatorProps) {
  if (users.length === 0) return null;

  const text = getTypingText(users);

  return (
    <div className="px-4 py-2 border-t border-gray-100 dark:border-gray-700">
      <div className="flex items-center gap-2 text-sm text-theme-tertiary">
        {/* Animated dots */}
        <div className="flex gap-1">
          <span className="w-1.5 h-1.5 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-1.5 h-1.5 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-1.5 h-1.5 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <span>{text}</span>
      </div>
    </div>
  );
}

function getTypingText(users: TypingUser[]): string {
  if (users.length === 1) {
    return `${users[0].user_name} is typing...`;
  }

  if (users.length === 2) {
    return `${users[0].user_name} and ${users[1].user_name} are typing...`;
  }

  return `${users[0].user_name} and ${users.length - 1} others are typing...`;
}
